import { countries } from "../../utils/constant";
import SelectBox from "./SelectBox";

const CountrySelectBox = ({ country_name, change }) => {
  return (
    <>
      <SelectBox
        isLoading={false}
        options={countries}
        name="country_name"
        val={country_name}
        change={change}
      />

      <style>
        {`
        .select__value-container{
        padding:0;
        }
        .select__control,.css-13cymwt-control {
            width: 100%;
    height: 55px;
    border: 1px solid #d6d6d6;
    border-radius: 12px;
    padding: 0 2px 0 15px;
    font-size: 15px;
    font-weight: 500;
            transition: all 0.2s ease-in-out;
            color: #232e35;

        }

            .select__control--is-focused,
.select__control--menu-is-open{
           border: 1px solid #d6d6d6 !important;      
            box-shadow: 0 0 0 2px rgba(255,255,255,0.17) !important;
            outline: none !important;
        }

        .select__input-container input ,.select__placeholder,.select__single-value {
  color: #232e35 !important;
  caret-color: #232e35 !important;  
}
        `}
      </style>
    </>
  );
};

export default CountrySelectBox;
